<template>
  <div class="article-feature">
    <component
      v-if="stringifiedHeading"
      :is="componentType"
      :id="stringifiedHeading"
    >
      <span v-if="typeof content === 'string'">{{ content }}</span>
      <span
        v-else
        v-for="(text, idx) in content"
        v-bind:key="idx"
      >
        <span v-if="typeof text === 'string'">{{ text }}</span>
        <enhanced-text
          v-else
          :value='text.value'
          :type='text.type'
        ></enhanced-text>
      </span>
    </component>
    <component
      v-else
      :is="componentType"
      :id="stringifiedHeading"
    >
      <span v-if="typeof content === 'string'">{{ content }}</span>
      <span
        v-else
        v-for="(text, idx) in content"
        v-bind:key="idx"
      >
        <span v-if="typeof text === 'string'">{{ text }}</span>
        <enhanced-text
          v-else
          :value='text.value'
          :type='text.type'
        ></enhanced-text>
      </span>
    </component>
  </div>

</template>

<script>
import EnhancedText from './components/enhanced-text/index.vue'

export default {
  props: ['content', 'level'],
  computed: {
    componentType() {
      if (this.level === 2) return 'h2'
      return 'h3'
    },
    stringifiedHeading() {
      if (!this.content) return null

      return Array.isArray(this.content) ? this.content.join(' ') : this.content
    }
  },
  components: {
    EnhancedText
  }
}
</script>

<style scoped lang="postcss">
  .article-feature {
    padding: 0 18px 0;
  }

  .article-feature > h2,
  .article-feature > h3 {
    color: inherit;
    float: none;
    padding: 10px 0;
    float: none;
    font-family: NRK Etica Slab;
    margin: 0;
  }

  .article-feature > h3 {
    text-align: center;
    font-size: 1.45em;
    margin-top: 30px;
  }

  .article-feature > h2 {
    text-align: center;
    font-weight: 500;
    font-size: 1.8em;
    margin: 0;
    padding: 0 0 60px;

    @media (min-width: 900px) {
      padding-bottom: 100px;
      font-size: 2em;
    }
  }
</style>
